import { COMMON_SET_AGREEMENT_LINK, COMMON_RESET } from "./actionTypes";

export const setAgreementLink = (link) => ({
  type: COMMON_SET_AGREEMENT_LINK,
  payload: link,
});

export const commonReset = () => ({
  type: COMMON_RESET,
});
